<style lang="scss">
.calls {}
</style>

<!-- eslint-disable -->
<template>
  <div class="theme-color-wrapper p-2">
    <div class="calls row max-page-width-small">
      <div class="col-12">
        <h2 cy="page-title" class="font-weight-bolder mb-3">Calls</h2>

        <section class="row p-relative">
          <loader v-if="loading"></loader>
          <div class="col-sm-4">
            <icon-card cy="requested"
              tooltip="These are calls that need your approval"
              route="requested-calls"
              icon="PhoneIcon"
              color="info"
              :statistic="requestedVisits"
              statistic-title="Requested Calls"></icon-card>
          </div>
          <div class="col-sm-4">
            <icon-card cy="awaiting"
              tooltip="These are calls you have approved and are waiting for the visitor to accept"
              route="awaiting-calls"
              icon="PhoneIcon"
              color="info"
              :statistic="awaitingConfirmationVisits"
              statistic-title="Awaiting Confirmation"></icon-card>
          </div>
          <div class="col-sm-4">
            <icon-card cy="approved"
              tooltip="These are calls both you and the visitor have approved"
              route="approved-calls"
              icon="PhoneIcon"
              color="info"
              :statistic="approvedVisits"
              statistic-title="Approved Calls"></icon-card>
          </div>
        </section>


        <section class="quick-links">
          <b-btn :to="{name: 'book-call'}" class="full-width mb-1" variant="primary">Book Video Calls for {{'prisoner' | term(true)}}</b-btn>
          <b-btn v-if="prison && prison.allow_offsite_calls" :to="{name: 'book-call-offsite'}" class="full-width mb-1" variant="primary">Book Inter-{{ 'prison' | term(true) }} Call</b-btn>
          <b-btn v-if="prison && prison.allow_intake_visits" :to="{name: 'book-intake-call'}" class="full-width mb-1" variant="primary">Book PV on Demand</b-btn>
          <b-btn :to="{name: 'completed-calls'}" class="full-width mb-1" variant="primary">View Completed Calls, Audio Logs and Recordings</b-btn>
          <b-btn :to="{name: 'cancelled-calls'}" class="full-width mb-1" variant="primary">View Cancelled Calls</b-btn>
        </section>
      </div>
    </div>
    <requested-reminder v-if="prison && requestedVisits" :calls="requestedVisits"></requested-reminder>
  </div>
</template>
<!-- eslint-enable -->

<script>
import { mapState } from 'vuex';
import IconCard from '@/components/cards/IconCard.vue';
import VisitService from '@/services/VisitService';
import { logger } from '@/util/logger';
import RequestedReminder from '@/components/requestedReminder/RequestedReminder.vue';

export default {
  components: {
    IconCard,
    RequestedReminder,
  },
  data() {
    return {
      loading: true,
      requestedVisits: 0,
      awaitingConfirmationVisits: 0,
      approvedVisits: 0,
      statsIntervalId: '',
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      prison: state => state.prison.prison,
    }),
  },
  beforeDestroy() {
    clearInterval(this.statsIntervalId);
  },
  async mounted() {
    await this.$store.dispatch('prison/getPrison');
    this.fetchStats();
    this.pollStats();
  },
  methods: {
    pollStats() {
      this.statsIntervalId = setInterval(() => {
        this.fetchStats();
      }, 10000);
    },
    fetchStats() {
      VisitService.getPrisonStats().then(res => {
        this.requestedVisits = res.data.requested;
        this.awaitingConfirmationVisits = res.data.awaitingConfirmation;
        this.approvedVisits = res.data.approved;
      }).catch(err => {
        logger.error('Error getting visit stats', err, null, 'Visits:fetchStats');
        this.$toast.error('Could not get visit stats', {
          toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
        });
        clearInterval(this.statsIntervalId);
      }).finally(() => {
        this.loading = false;
      });
    },
  },
}
</script>
